import axios from "axios";
import { ApiException } from "./ApiExceptions";
import {
  IDocumentDOE,
  IActiveDOE,
  IRequestPageDOE,
  ISimpleDOE,
  IUpdateDOE,
  IReportListDOE,
  ISendToPrintshopDOE,
  ITableValidateDOE
} from "@/store/types/doe-types";
import { FilterPaged } from "@/store/types/types";

// DOE End Points
export const getPendingList = ({
  page,
  order_by,
  paginator_count = 10,
  search,
  filters,
  ignore_order_by_priority
}: FilterPaged) =>
  axios({
    url: "process/doe/pending/list",
    method: "GET",
    params: {
      page,
      order_by,
      paginator_count,
      search,
      ignore_order_by_priority,
      ...filters
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const refusePublish = (listDocuments: IDocumentDOE[]) =>
  axios({
    url: `process/doe/refuse-publish/`,
    method: "PATCH",
    data: listDocuments
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const publish = (listDocuments: IDocumentDOE[]) =>
  axios({
    url: `process/doe/publish-doe/`,
    method: "PATCH",
    data: listDocuments
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getProgrammedList = ({
  page,
  order_by,
  paginator_count = 10,
  search,
  filters,
  ignore_order_by_priority
}: FilterPaged) =>
  axios({
    url: `process/doe/programmed/list`,
    method: "GET",
    params: {
      page,
      order_by,
      paginator_count,
      search,
      ...filters,
      ignore_order_by_priority
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const programPublish = (listDocuments: IDocumentDOE[]) =>
  axios({
    url: `process/doe/program-publish/`,
    method: "PATCH",
    data: listDocuments
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getRefusedList = ({
  page,
  order_by,
  paginator_count = 10,
  search,
  filters,
  ignore_order_by_priority
}: FilterPaged) =>
  axios({
    url: `process/doe/refused/list`,
    method: "GET",
    params: {
      page,
      order_by,
      paginator_count,
      search,
      ...filters,
      ignore_order_by_priority
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getPublishedList = ({
  page,
  order_by,
  paginator_count = 10,
  search,
  filters,
  ignore_order_by_priority
}: FilterPaged) =>
  axios({
    url: `process/doe/published/list`,
    method: "GET",
    params: {
      page,
      order_by,
      paginator_count,
      search,
      ...filters,
      ignore_order_by_priority
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const setToSentToPrintshop = (
  sentToPrintshopList: ISendToPrintshopDOE[]
) =>
  axios({
    url: `process/doe/sent-to-printshop/`,
    method: "PATCH",
    data: sentToPrintshopList
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const doeReportListFile = (data: IReportListDOE) =>
  axios({
    url: `process/doe/create-programmed-report-list-file/`,
    method: "POST",
    data
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

// Edoweb
export const createModelDocumentEdoweb = ({
  document_json,
  name,
  short_name,
  all_parts,
  parts,
  document_type,
  nature,
  use_type
}: IUpdateDOE) =>
  axios({
    url: `process/edoweb/document/model/create`,
    method: "POST",
    data: {
      document_json,
      name,
      short_name,
      all_parts,
      parts,
      document_type,
      nature,
      use_type
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const updateModelDocumentEdoweb = ({
  document_json,
  id,
  name,
  short_name,
  all_parts,
  parts,
  document_type,
  nature,
  use_type
}: ISimpleDOE) =>
  axios({
    url: `process/edoweb/document/model/edit/${id}`,
    method: "PUT",
    data: {
      document_json,
      name,
      short_name,
      all_parts,
      parts,
      document_type,
      nature,
      use_type
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const getModelDocumentEdoweb = (id: string) =>
  axios({
    url: `process/edoweb/document/model/${id}`,
    method: "GET"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const listModelDocumentEdoweb = ({
  page,
  paginator_count = 10,
  search,
  document_type,
  order_by,
  part,
  ignore_order_by_default
}: IRequestPageDOE) =>
  axios({
    url: `process/edoweb/document/model/list/`,
    method: "GET",
    params: {
      page,
      paginator_count,
      search,
      document_type,
      order_by,
      part,
      ignore_order_by_default
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const listModelDocumentEdowebAdm = ({
  page,
  paginator_count = 10,
  search,
  document_coverage,
  document_type,
  order_by,
  part,
  status,
  ignore_order_by_default
}: IRequestPageDOE) =>
  axios({
    url: `process/edoweb/document/model/adm/list/`,
    method: "GET",
    params: {
      page,
      paginator_count,
      search,
      document_coverage,
      document_type,
      order_by,
      part,
      status,
      ignore_order_by_default
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const deleteModelDocumentEdoweb = (id: string) =>
  axios({
    url: `process/edoweb/document/model/delete/${id}`,
    method: "DELETE"
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const activeModelDocumentEdoweb = ({ id, active }: IActiveDOE) =>
  axios({
    url: `process/edoweb/document/model/activate/${id}`,
    method: "PUT",
    data: {
      active
    }
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });

export const validateDocumentEdoweb = (data: ITableValidateDOE) =>
  axios({
    url: `process/file/move-bucket`,
    method: "POST",
    data
  })
    .then(response => {
      return { kind: "ok", data: response.data };
    })
    .catch(error => {
      return ApiException(error.response);
    });
